import { useAppToken } from "../../../theme/v6/useAppToken";
import React from "react";

import { Flex, Layout } from "antd";

import { LAYOUT_HEADER_HEIGHT } from "../../constants";
import ThemeModeSwitch from "../../../theme/ThemeModeSwitch";

type Props = React.PropsWithChildren;

function StickyHeader({ children }: Props) {
  const { token } = useAppToken();

  return (
    <Layout.Header
      style={{
        borderBlockEnd: `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`,
        height: LAYOUT_HEADER_HEIGHT,
        lineHeight: `${LAYOUT_HEADER_HEIGHT}px`,
        position: "sticky",
        top: 0,
        zIndex: token.zIndexPopupBase,
      }}
    >
      <Flex align="center" gap={8} style={{ height: "100%" }}>
        <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
        <ThemeModeSwitch />
      </Flex>
    </Layout.Header>
  );
}

export default React.memo(StickyHeader);
